import { render } from "./SearchforvehicleView.vue?vue&type=template&id=45c5d71c"
import script from "./SearchforvehicleView.vue?vue&type=script&lang=js"
export * from "./SearchforvehicleView.vue?vue&type=script&lang=js"

import "./SearchforvehicleView.vue?vue&type=style&index=0&id=45c5d71c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__